import Grid from "@material-ui/core/Grid"
import withStyles from "@material-ui/styles/withStyles"
import React, { Component } from "react"

import { knowledgeAreaArray } from "../../Constants"
import Wrapper from "../../components/Common/Wrapper"
import SectionHeader from "../../components/SectionHeader"
import ScheduleTable from "../../components/Table/ScheduleTable"
import { convertTimestampToReadableDate } from "../../utils"

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: '30px',
    },
    grid: {
        width: 1200,
        marginTop: 40,
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 20px)"
        }
    },
    paper: {
        padding: theme.spacing(3),
        textAlign: "left",
        color: theme.palette.text.secondary
    },
    rangeLabel: {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: theme.spacing(2)
    },
    topBar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 32
    },
    outlinedButtom: {
        textTransform: "uppercase",
        margin: theme.spacing(1)
    },
    actionButtom: {
        textTransform: "uppercase",
        margin: theme.spacing(1),
        width: 152
    },
    blockCenter: {
        padding: theme.spacing(2),
        textAlign: "center"
    },
    block: {
        padding: theme.spacing(2)
    },
    box: {
        marginBottom: 40,
        height: 65
    },
    inlining: {
        display: "inline-block",
        marginRight: 10
    },
    buttonBar: {
        display: "flex"
    },
    alignRight: {
        display: "flex",
        justifyContent: "flex-end"
    },
    noBorder: {
        borderBottomStyle: "hidden"
    },
    loadingState: {
        opacity: 0.05
    },
    loadingMessage: {
        position: "absolute",
        top: "40%",
        left: "40%"
    }
})

class Schedule extends Component {

    state = {
        iPGA: false,
        loaded: true,
        papers: []
    }

    generalScheduleCols = ["Horário", "Título", "Tipo", "Local"]

    generalScheduleData = [
        ["09:00 - 09:30", "Credenciamento", "Credenciamento", "Hall em frente ao Auditório CBS01"],
        ["09:30 - 10:10", "Prof. Jacques Mick - Pró-Reitor de Pesquisa - “Ciência e Inovações na UFSC”", "Palestra de abertura", "Auditório CBS01"],
        ["10:20 - 11:00", "Roda de conversa", "Roda de conversa", "Auditório CBS01"],
        ["14:00 - 14:40", "Eng. Agr.Maykol Ouriques (EPAGRI) - Oportunidades e Inovações no Agro", "Palestra", "Auditório CBS01"],
        ["14:50 - 15:30", "Roda de conversa", "Roda de conversa", "Auditório CBS01"],
        ["15:30 - 16:00", "Exposição de empresa/Apresentação oral dos resumos selecionados (PG em Agronomia/Eng. Florestal da UFSC Curitibanos)", "Exposição", "Hall do CBS01"],

    ]
    generalScheduleData2 = [
        ["09:00 - 09:40", "Palestra - Bruno Polli Domanowski - “Inteligência de Mercado Florestal da Suzano Papel e Celulose”", "Palestra", "Auditório CBS01"],
        ["09:50 - 10:20", "Roda de conversa", "Roda de conversa", "Auditório CBS01"],
        ["10:30 - 11:00", "Exposição de empresas", "Exposição", "Hall do CBS01"],
        ["14:00 - 15:00", "Exposição de banners (Graduação e PG em Agronomia/Eng. Florestal da UFSC Curitibanos e empresas)", "Exposição", "Hall do CBS01"],
        ["14:00 - 15:00", "Apresentação oral dos resumos selecionados – (Graduação e PG em Med. veterinária da UFSC Curitibanos)", "Apresentação Oral", "Auditório CBS01"],
        ["15:15 - 18:00", "Marco Antônio Lucini, Hamilton J. Viera e Gerson Santino Cecconello - Workshop “Cultivo do alho: inovações para reestruturação.”", "Workshop", "CC1102 no CBS01"],
        ["15:15 - 18:00", "Prof. Amanda Köche Marcon - Workshop “Dendrocronologia para além da idade das árvores: inovações e aplicações florestais.”", "Workshop", "CBS01 - sala 203"],
        ["15:15 - 18:00", "Profa Júlia Carina Niemeyer - Workshop “Curriculum Lattes: sabe preencher?”", "Workshop", "Lab. de informática do CBS01"]
    ]
    generalScheduleData3 = [
        ["09:00 - 09:40", "Prof. Andreas Lazaros Chryssafidis - Palestra “Inovações na Medicina Veterinária”", "Palestra", "Auditório CBS01"],
        ["09:50 - 10:20", "Roda de conversa", "Roda de conversa", "Auditório CBS01"],
        ["10:30 - 11:30", "Exposição de banners  (Graduação e PG em Med.veterinária da UFSC Curitibanos, outras Graduações e PGs da UFSC, outras Instituições e empresas)", "Exposição", "Hall do CBS01"],
        ["10:30 - 11:30", "Apresentação oral dos resumos selecionados (Graduação Agronomia/Eng. Florestal da UFSC Curitibanos)", "Apresentação Oral", "Auditório CBS01"],
        ["13:30", "Entrega de prêmios e Encerramento", "Encerramento", "Auditório CBS01"],
    ];


    columns = [
        {
            name: "paperTitle",
            label: "Título",
            options: {
                filter: false
            }
        },
        {
            name: "startingAt",
            label: "Início",
            options: {
                customBodyRender: (val) => {
                    return <span>{convertTimestampToReadableDate(val)}</span>
                }
            }
        },
        {
            name: "endingAt",
            label: "Fim",
            options: {
                customBodyRender: (val) => {
                    return <span>{convertTimestampToReadableDate(val)}</span>
                }
            }
        },
        {
            name: "knowledgeArea",
            label: "Área de Conhecimento",
            options: {
                customBodyRender: (val) => {
                    const area = knowledgeAreaArray.find(k => val === k.value)
                    return <span>{area.title}</span>
                }
            }
        },
    ]


    render() {
        const currentPath = this.props.location.pathname
        const { iPGA, day1, day2, oral } = this.state

        return (

            <Wrapper currentPath={currentPath} footer={true} loaded={this.state.loaded} error={this.state.error}>
                <Grid
                    container
                    justify="space-around" alignContent="center" alignItems="center">
                    <Grid item xs={10}>
                        <SectionHeader
                            title="Programação"
                            subtitle=""
                        />
                    </Grid>
                    <Grid item xs={10}>
                        <ScheduleTable data={this.generalScheduleData} columns={this.generalScheduleCols} title={"Data 11/09/2024"} />
                        <br />
                    </Grid>
                    <Grid item xs={10}>
                        <ScheduleTable data={this.generalScheduleData2} columns={this.generalScheduleCols} title={"Data 12/09/2024"} />
                        <br />
                    </Grid>
                    <Grid item xs={10}>
                        <ScheduleTable data={this.generalScheduleData3} columns={this.generalScheduleCols} title={"Data 13/09/2024"} />
                        <br />
                    </Grid>
                </Grid>
                <br />
                {
                    iPGA &&
                    <Grid
                        container
                        justify="space-around" alignContent="center" alignItems="center">
                        <Grid item xs={10}>
                            <ScheduleTable data={day1} columns={this.columns} title={"Apresentações Banner - 12/09/2024"} />
                            <br />
                            <ScheduleTable data={day2} columns={this.columns} title={"Apresentações Banner - 12/09/2024"} />
                            <br />
                            <ScheduleTable data={oral} columns={this.columns} title={"Apresentações Oral - 12/09/2024"} />
                        </Grid>
                    </Grid>
                }
            </Wrapper>
        )
    }
}
export default withStyles(styles)(Schedule)
